import { css } from 'lit'

export const voyageTopbarStyles = [
    css`
        .voyage-topbar {
            display: grid;
            grid-template-columns: auto 1fr auto 1fr;
            grid-template-rows: 1fr;
            align-items: center;
            justify-content: center;
            width: 100%;
            background: var(--neutrals-grey-10, white);
            user-select: none;
        }

        .voyage-topbar--box-shadow {
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
        }

        .voyage-topbar-wrapper {
            position: relative;
        }
        
        .logo-wrapper {
            grid-column: 1;
            display: flex;
            align-items: center;
        }

        .name {
            color: var(--primary-blue-900, white);
            font-family: var(--component-heading-ff, 'serif');
            font-size: 20px;
            line-height: 24px;
            font-weight: normal;
            margin: 0 0px 0 24px;
        }

        .logo-divider {
            border-left: 3px solid var(--primary-blue-300, blue);
            width: 1px;
            height: 15px;
            margin: 2px 4px 0px 6px;
        }

        .app-name {
            color: var(--primary-blue-900, blue);
            font-family: var(--component-heading-ff, 'serif');
            font-size: 20px;
            line-height: 24px;
            font-weight: bold;
        }

        .logo {
            display: flex;
            align-items: center;
            height: 49px;
        }

        .left {
            display: flex;
            align-items: center;
        }

        .application-links-dropdown {
            position: absolute;
            top: 48px;
            left: 219px;
            min-width: 200px;

            background: var(--neutrals-grey-10, white);
            border: 1px solid var(--neutrals-grey-06, grey);
            box-sizing: border-box;
        }

        .application-info,
        .application-link {
            display: flex;
            align-items: center;

            color: var(--neutrals-grey-03, black);
            font-family: var(--component-paragraph-ff, 'serif');
            font-size: 18px;
            line-height: 24px;
            font-weight: var(--component-paragraph-weight, normal);
            text-decoration: none;
        }

        .link {
            cursor: pointer;
        }

        .application-link > svg,
        .application-info > svg {
            width: 11px;
            height: 13px;
            fill: currentColor;
        }

        svg {
            margin: 4px;
        }

        .settings {
            display: flex;
            align-items: center;
            cursor: pointer;
        }

        .feedback {
            display: flex;
            align-items: center;
            cursor: pointer;
        }

        .settings > svg {
            width: 22px;
            height: 22px;
            fill: var(--neutrals-grey-03, black);
        }

        .application-link {
            padding: 10px 10px 10px 0;
        }

        .version {
            text-transform: uppercase;
            margin-top: -10px;
            border-radius: 6px;
            line-height: 12px;
            padding: 2px 4px 2px 8px;
            font-size: 12px;
            font-family: MaerskText;
        }

        .settings-links-dropdown {
            position: absolute;
            top: 48px;
            right: 15px;
            z-index: 1;
            background: var(--neutrals-grey-10, white);
            border: 1px solid var(--neutrals-grey-07, grey);
            border-radius: 3px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
            box-sizing: border-box;
            padding: 15px;
        }

        .settingsEntry {
            padding: 0;
            display: flex;
            align-items: center;

            color: var(--neutrals-grey-03, black);
            font-family: MaerskText;
            font-size: 14px;

            cursor: pointer;
        }

        .settingsEntry > svg {
            width: 16px;
            height: 16px;
            fill: currentColor;
            margin-left: 0;
        }

        .datetime {
            grid-column: 3;

            color: var(--neutrals-grey-02, black);
            font-family: var(--component-paragraph-ff, 'serif');
            font-size: 16px;
            line-height: 24px;
            font-weight: var(--component-paragraph-weight, normal);
        }

        .right {
            grid-column: 4;
            justify-self: right;

            display: flex;
            align-items: center;
        }

        button {
            background: none;
            border: none;
        }

        .release-notes {
            display: block;
            position: absolute;
            top: 100px;
            right: 20px;
            min-width: 600px;
            min-height: 400px;
            background: var(--neutrals-grey-08, white);
            border-style: solid;
            border-width: 1px;
            border-color: black;
        }

        .release-notes-close {
            position: absolute;
            top: 0px;
            right: 10px;
            cursor: pointer;
            fill: var(--neutrals-grey-02, black);
        }

        .release-notes-close > svg {
            width: 10px;
        }

        .release-notes-object {
            font-family: Arial, Helvetica, sans-serif;
            width: 600px;
            height: 400px;
        }

        .forecast {
            display: flex;
            align-items: center;
            font-family: MaerskText;
            font-size: 12px;
            fill: currentColor;
            border-radius: 3px;
            padding-right: 5px;
        }

        .forecast[status='green'] {
            color: var(--voyage-good-green, green);
        }

        .forecast[status='yellow'] {
            color: var(--warning-yellow-8, yellow);
        }

        .forecast[status='red'] {
            color: var(--voyage-error-red, red);
        }

        .imoError {
            grid-column: 2;
            color: var(--voyage-error-red, red);
            padding-right: 5px;
            cursor: pointer;
        }

        .forecastIcon {
            height: 13px;
            width: 15px;
            margin: 5px;
        }

        .forecastIcon > svg {
            height: 100%;
            width: 100%;
            margin: 0;
        }

        .low-res-pill {
            justify-self: flex-end;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 56px;
            height: 18px;
            border-radius: 10px;
            margin-left: 5px;
        }

        .low-res-pill span {
            color: white;
        }

        voyage-tooltip {
            --tooltip-background-color: var(--primary-blue-01);
            font-family: MaerskText;
            font-size: 14px;
        }

        .hard-refresh-text {
            font-size: 14px;
            font-family: MaerskText;
            padding-left: 20px;
            padding-right: 20px;
            color: var(--primary-blue-700, blue);
        }
        .last-position {
            margin-right: 24px;
            font-family: MaerskText;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            letter-spacing: 0px;
            text-align: left;
            color: var(--functional-grey-700, gray);
        }
        .migrate-button {
            margin-left: 10px;
        }

        .migration-panel {
            position: absolute;
            height: 240px;
            width: 423px;
            margin-top: 20px;
        }

        .migration-container {
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: space-between;
        }

        .migration-panel-buttons {
            align-self: flex-end;
            position: absolute;
            bottom: 16px;
        }

        .failed-message {
            display: flex;
            box-sizing: border-box;
            align-items: center;
            width: 100%;
            height: 44px;
            background-color: var(--feedback-danger-light, red);
            border-radius: 4px;
            padding: 12px;
            margin-bottom: 6px;
            pointer-events: none;
        }
        .failed-message svg {
            width: 16px;
            margin-right: 14px;
        }

        .failed-text {
            padding-bottom: 4px;
        }
    `,
]
